// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"99":"4fd8efa6","818":"d0f563f9"}[chunkId] + ".js";
};